import type { DocDefinition } from "./types";

/** Fallback seed when catalog.json is unavailable */
const SEED_DOCS: DocDefinition[] = [
  {
    id: "meta.brief",
    index: "设定",
    title: "交付说明与书名",
    shortTitle: "交付说明",
    file: "/content/meta/交付说明与书名.md",
    group: "meta",
  },
  {
    id: "meta.bible",
    index: "设定",
    title: "人设圣经",
    shortTitle: "人设圣经",
    file: "/content/meta/人设圣经.md",
    group: "meta",
  },
  {
    id: "meta.world",
    index: "设定",
    title: "世界观与家族",
    shortTitle: "世界观",
    file: "/content/meta/世界观与家族.md",
    group: "meta",
  },
  {
    id: "meta.plan",
    index: "设定",
    title: "全书分卷总纲",
    shortTitle: "分卷总纲",
    file: "/content/meta/全书分卷总纲.md",
    group: "meta",
  },
  {
    id: "meta.titles",
    index: "设定",
    title: "正式章节名",
    shortTitle: "章节名",
    file: "/content/meta/正式章节名.md",
    group: "meta",
  },
  {
    id: "outline.v1",
    index: "细纲",
    title: "第一卷细纲",
    shortTitle: "卷一细纲",
    file: "/content/outline/卷一细纲.md",
    group: "outline",
    volume: 1,
  },
  {
    id: "outline.v2",
    index: "细纲",
    title: "第二卷细纲",
    shortTitle: "卷二细纲",
    file: "/content/outline/卷二细纲.md",
    group: "outline",
    volume: 2,
  },
  {
    id: "outline.v3",
    index: "细纲",
    title: "第三卷细纲",
    shortTitle: "卷三细纲",
    file: "/content/outline/卷三细纲.md",
    group: "outline",
    volume: 3,
  },
  {
    id: "outline.v4",
    index: "细纲",
    title: "第四卷细纲",
    shortTitle: "卷四细纲",
    file: "/content/outline/卷四细纲.md",
    group: "outline",
    volume: 4,
  },
  {
    id: "ch.v1.c01",
    index: "01",
    title: "正文·卷一第01章 周年",
    shortTitle: "第01章 周年",
    file: "/content/chapters/v1/第01章_周年.md",
    group: "draft",
    volume: 1,
  },
];

export let DOCS: DocDefinition[] = [...SEED_DOCS];
export let DOC_BY_ID = new Map(DOCS.map((doc) => [doc.id, doc]));

export function setDocs(docs: DocDefinition[]): void {
  DOCS = docs;
  DOC_BY_ID = new Map(docs.map((doc) => [doc.id, doc]));
}

/** Old flat numeric doc_ids → new ids (comments compatibility) */
export const LEGACY_DOC_ID_MAP: Record<string, string> = {
  "00": "meta.brief",
  "01": "meta.bible",
  "02": "meta.world",
  "03": "meta.plan",
  "04": "outline.v1",
  "05": "outline.v2",
  "06": "outline.v3",
  "07": "outline.v4",
  "08": "ch.v1.c01",
};

export function resolveDocId(id: string): string {
  return LEGACY_DOC_ID_MAP[id] || id;
}

export function getDocById(id: string): DocDefinition | undefined {
  return DOC_BY_ID.get(resolveDocId(id));
}

export const DOC_GROUPS: { id: DocDefinition["group"]; label: string }[] = [
  { id: "meta", label: "设定" },
  { id: "outline", label: "细纲" },
  { id: "draft", label: "正文" },
];

export const VOLUME_LABEL: Record<number, string> = {
  1: "卷一",
  2: "卷二",
  3: "卷三",
  4: "卷四",
};

export const STORAGE = {
  author: "wl_v2_author",
  theme: "wl_v2_theme",
  currentDoc: "wl_v2_current_doc",
  scrollPositions: "wl_v2_scroll_positions",
  navGroups: "wl_v3_nav_groups",
  fontScale: "wl_v3_font_scale",
  /** 编辑草稿备份的 key 前缀，后接 docId */
  editDraft: "wl_v3_edit_draft:",
} as const;

export const LEGACY_STORAGE_KEYS = [
  "wl_v1_pass",
  "wl_pass_v6",
  "wl_site_pass_v4",
  "wl_admin_pass_v4",
  "wl_token_v2",
  "wl_token",
  "wl_pass",
];

export const MOBILE_BREAKPOINT = 760;
export const COMMENTS_DRAWER_BREAKPOINT = 1180;
